import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

export function isEligibleForTWCPlanSelectionPage(context: EditionAwarenessContextType): boolean {
	const { product, edition, isInCollection, userRoles } = context;

	return Boolean(
		isEditionOneOf(edition, ['free']) &&
		isInCollection === 'IN_COLLECTION' &&
		isProductOneOf(product, ['jira', 'confluence']) &&
		userRoles?.includes('BILLING_ADMIN'),
	);
}
